const addBackPlusSignToEmail = (email: string) => {
  if (!email) return '';

  return email.replace(/ /g, '+');
};

export default addBackPlusSignToEmail;
